export class M3DETCONDIPROMO{
    public IdPromocion:number;
    public IdCondicion:number;
    public Concepto:string;
    public Valor:string;
    public JAdicionales:string;
}